import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-section" }
const _hoisted_2 = { class: "map-section__body" }
const _hoisted_3 = { class: "map-section__controls" }
const _hoisted_4 = { class: "map-section__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_BaseFilterBlock = _resolveComponent("BaseFilterBlock")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_DashboardsMap = _resolveComponent("DashboardsMap")!
  const _component_DashboardsRatingTooltipContent = _resolveComponent("DashboardsRatingTooltipContent")!
  const _component_DashboardsRatingCard = _resolveComponent("DashboardsRatingCard")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "title title--regions-economic cursor-pointer" }, " Тепловая карта субъектов РФ по рейтингу активности внешнеэкономических связей ", -1)),
      _createVNode(_component_DateActualDataSubtitle, {
        class: "map-section__subtitle",
        filter: _ctx.filter,
        isSimpleYearLabel: _ctx.isSimpleYearLabel
      }, null, 8, ["filter", "isSimpleYearLabel"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseFilterBlock, {
          placeholders: { region: 'Все субъекты РФ' },
          onChangeFilter: _ctx.changeBaseFilter
        }, null, 8, ["onChangeFilter"]),
        _createVNode(_component_ButtonComponent, {
          class: "map-section__button button-redesign--download-icon-fill button-redesign--mobile-full",
          disabled: _ctx.getIsDisableButton,
          onClick: _ctx.openCard
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Открыть карточку субъекта РФ ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_DashboardsMap, {
          class: "map-section__map",
          listRegionEffective: _ctx.getTopEffectiveRegionsWithRating,
          year: _ctx.filter.year,
          isLoading: _ctx.isMapLoading
        }, null, 8, ["listRegionEffective", "year", "isLoading"]),
        _createVNode(_component_DashboardsRatingCard, {
          title: _ctx.ratingCardTitles.HIGHEST,
          class: "map-section__card",
          list: _ctx.topEffectiveRegionsRatingWithIndex,
          isLoading: _ctx.isRatingLoading,
          isShowDynamic: _ctx.isShowDynamicInRatingCards,
          year: _ctx.filter.year,
          sortOrder: _ctx.exportRegionEffectivnessRatingExcelSortOrder.DESCENDING
        }, {
          tooltipContent: _withCtx(() => [
            _createVNode(_component_DashboardsRatingTooltipContent)
          ]),
          _: 1
        }, 8, ["title", "list", "isLoading", "isShowDynamic", "year", "sortOrder"]),
        _createVNode(_component_DashboardsRatingCard, {
          title: _ctx.ratingCardTitles.LOWEST,
          class: "map-section__card",
          list: _ctx.getTopEffectiveRegionsRatingReverseWithIndex,
          isShowDynamic: _ctx.isShowDynamicInRatingCards,
          isLoading: _ctx.isRatingLoading,
          year: _ctx.filter.year,
          sortOrder: _ctx.exportRegionEffectivnessRatingExcelSortOrder.ASCENDING
        }, null, 8, ["title", "list", "isShowDynamic", "isLoading", "year", "sortOrder"])
      ])
    ])
  ]))
}